<template>
  <div class="invoices-page px-2 pt-8 md:pb-24">
    <vs-table
        stripe
      :data="invoices">
      <template slot="thead">
        <vs-th class="table-head">
            <div class="table-cell">
                Date
            </div>
        </vs-th>

        <vs-th class="table-head">
            <div class="table-cell">
                Starting Balance
            </div>
        </vs-th>

        <vs-th class="table-head">
            <div class="table-cell">
                Consumption
            </div>
        </vs-th>
        <vs-th class="table-head">
            <div class="table-cell">
                Ending Balance
            </div>
        </vs-th>

        <vs-th class="table-head">
            <div class="table-cell">
                Invoice
            </div>
        </vs-th>

      </template>

      <template slot-scope="{data}">

        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="data[indextr].date">
            <div class="table-body">
              {{ data[indextr].date | moment('YYYY-MM-DD') }}
            </div>
          </vs-td>

          <vs-td>
            <div class="table-body">
                ${{data[indextr].starting_balance}}
            </div>
          </vs-td>

          <vs-td>
            <div class="table-body">
                ${{data[indextr].consumption}}
            </div>
          </vs-td>

          <vs-td>
            <div class="table-body">
                ${{data[indextr].ending_balance}}
            </div>
          </vs-td>

          <vs-td class="dynamic-width">
              <div class="table-body">
                <a class="pdf-ptn" @click="downloadInvoice(data[indextr].id)">Download PDF</a>
              </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>


    <div class="pt-8 mb-5 flex flex-wrap md:flex-no-wrap">
        <div class="w-full mb-8 flex items-center md:mb-0 md:justify-end md:mr-2">
            <div class="show-rows mr-5">Show Rows</div>
            <v-select
                :options="pageCounts.options"
                label="name"
                class="pagination-selector w-full md:w-32"
                :value="selectedPageCount"
                @input="getSelectedPageCount"

            ></v-select>
        </div>
        <vs-pagination v-model="pageIndex" @change="getSelectedPage"  :total="totalPages" :max="maxItems"/>
    </div>


  </div>
</template>


<script>
export default {

  props: ['data', 'total', 'loading'],

  data () {
    return {
      pageCounts: {
        options: [10, 25, 50, 100]
      },
      pageIndex: 1,
      selectedPageCount: 10,
      shouldEmitSelectPage: false,
      maxItems: 5
    }
  },
  created () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    downloadInvoice (invoiceId) {
      window.axios.get(`/accounts/invoices/${invoiceId}/download`, {
        responseType: 'blob'
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'invoice.pdf') //or any other extension
          document.body.appendChild(link)
          link.click()
        })
    },

    getSelectedPageCount (selectedPageCount) {
      this.selectedPageCount = selectedPageCount
      this.$emit('select-page-count', selectedPageCount)
    },
    getSelectedPage (pageIndex) {
      if (this.shouldEmitSelectPage) {
        this.pageIndex = pageIndex
        this.$emit('select-page', pageIndex)
      } else {
        this.shouldEmitSelectPage = true
      }
    },
    handleResize () {
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
      this.maxItems = vw >= 768 ? 8 : 5
    }


  },

  computed: {
    invoices () {
      return this.data
    },
    totalPages () {
      return this.total !== 0 ? Math.ceil(this.total / this.selectedPageCount) : 1
    }

  }
}

</script>


<style lang="scss">
.dynamic-width {
  width: 1px;
  white-space: nowrap;
}

.time {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.107143px;
  color: #2c2c2c;
}

.table-head {
  background: rgba(0, 146, 215, 0.06);
  line-height: 24px;
  font-size: 16px;
  font-weight: 500;
}

.pdf-btn {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.107143px;
  color: #0092d7;
}

.table-cell {
  @apply py-4;
  @apply px-6;
  @apply whitespace-no-wrap;
}

.table-body {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #2c2c2c;

  @apply table-cell;
}

.show-rows {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  color: #2c2c2c;

  @apply whitespace-no-wrap;
}

.pagination-selector {
  background: #fff;
}

.invoices-page {
  .vs__clear {
    display: none;
  }

  .vs__dropdown-toggle {
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    border-radius: 20px;
  }
}

</style>
